import { retrieveRawInitData } from "@telegram-apps/bridge";
import { Expense, ExpenseCategory } from "../types";

const API_URL = 'https://kakeibo.theodorekrypton.workers.dev/api';

// the worker verifies Telegram's signed initData on every request
const request = async (path: string, init: RequestInit = {}) => {
  const response = await fetch(`${API_URL}${path}`, {
    ...init,
    headers: { Authorization: `tma ${retrieveRawInitData() ?? ''}` },
  });
  if (!response.ok) {
    throw new Error(`${init.method ?? 'GET'} ${path} failed with ${response.status}`);
  }
  return response;
};

export const addExpense = async (expense: Expense) => {
  return await request('/expense', {
    method: 'POST',
    body: JSON.stringify({ expense }),
  });
};

export const getExpenses = async (beginDate: string, endDate: string): Promise<Expense[]> => {
  const response = await request(`/expenses?begin=${beginDate}&end=${endDate}`);
  const data = await response.json();
  return data.map((expense: Expense) => ({
    ...expense,
    date: new Date(expense.date),
    category: expense.category as ExpenseCategory,
  } as Expense));
};

export const getExpense = async (id: number): Promise<Expense> => {
  const response = await request(`/expense?id=${id}`);
  const data = await response.json();
  return {
    ...data,
    date: new Date(data.date),
    category: data.category as ExpenseCategory,
  } as Expense;
};

export const updateExpense = async (id: number, expense: Expense) => {
  await request('/expense/update', {
    method: 'POST',
    body: JSON.stringify({
      id,
      expense,
    }),
  });
};

// messageId, when present, is the Telegram notification this expense was opened from; the worker
// deletes that message along with the record so its button can't point at a removed expense
export const removeExpense = async (id: number, messageId?: number) => {
  await request('/expense/remove', {
    method: 'POST',
    body: JSON.stringify({ id, messageId }),
  });
};
